"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AIRLINES_FILTER_TYPE = exports.FLIGHT_RESULTS_SORT_TYPES = exports.LOCATION_RESULTS_SORT_TYPES = exports.LOCATION_TYPES = exports.SKYPICKER_BASE_API_URL = void 0;
var SKYPICKER_BASE_API_URL = 'https://api.skypicker.com';
exports.SKYPICKER_BASE_API_URL = SKYPICKER_BASE_API_URL;
var LOCATION_TYPES = Object.freeze({
  AIRPORT: 'AIRPORT',
  AUTONOMOUS_TERRITORY: 'AUTONOMOUS_TERRITORY',
  CITY: 'CITY',
  COUNTRY: 'COUNTRY',
  STATION: 'STATION',
  SUBDIVISION: 'SUBDIVISION'
});
exports.LOCATION_TYPES = LOCATION_TYPES;
var LOCATION_RESULTS_SORT_TYPES = Object.freeze({
  ASCENDING_NAME: 'ASCENDING_NAME',
  ASCENDING_RANK: 'ASCENDING_RANK',
  DESCENDING_NAME: 'DESCENDING_NAME',
  DESCENDING_RANK: 'DESCENDING_RANK'
});
exports.LOCATION_RESULTS_SORT_TYPES = LOCATION_RESULTS_SORT_TYPES;
var FLIGHT_RESULTS_SORT_TYPES = Object.freeze({
  DATE: 'DATE',
  DURATION: 'DURATION',
  PRICE: 'PRICE',
  QUALITY: 'QUALITY'
});
exports.FLIGHT_RESULTS_SORT_TYPES = FLIGHT_RESULTS_SORT_TYPES;
var AIRLINES_FILTER_TYPE = Object.freeze({
  EXCLUDE: 'EXCLUDE',
  INCLUDE: 'INCLUDE'
});
exports.AIRLINES_FILTER_TYPE = AIRLINES_FILTER_TYPE;


//////////////////
// WEBPACK FOOTER
// ./~/skypicker/build/constants.js
// module id = 342
// module chunks = 231608221292675